module.exports = __webpack_public_path__ + "media/סבא.216226c7.mp3";